import api from "./configuration";
import apiUrl from "./url";
import store from "@/store";
const token = () => {
	const value = store.getState().token;
	if (!value) throw Error("Sessione non più attiva.");
	return value;
};
const json = async (method, path, data, params) =>
	(
		await api.request({
			method,
			url: apiUrl + path,
			data,
			params,
			useAuthInterceptor: false,
			headers: {Authorization: `Bearer ${token()}`},
		})
	).data;
const upload = async (path, file, fields = {}) => {
	const captured = token();
	const body = new FormData();
	body.append("file", file);
	Object.entries(fields).forEach(([k, v]) => {
		if (v !== null && v !== undefined) body.append(k, String(v));
	});
	const response = await fetch(apiUrl + path, {
		method: "POST",
		headers: {Authorization: `Bearer ${captured}`},
		body,
	});
	const data = await response
		.json()
		.catch(() => ({error: "Risposta non valida dal server."}));
	if (!response.ok) {
		const error = Error(data.error || "Operazione non riuscita.");
		error.response = {status: response.status, data};
		throw error;
	}
	return data;
};
export const ScoutingIndicesAPI = {
	list: () => json("GET", "/ScoutingIndices"),
	save: (index) =>
		json(
			index.version ? "PUT" : "POST",
			"/ScoutingIndices" +
				(index.version ? "/" + encodeURIComponent(index.id) : ""),
			index,
		),
	remove: (index) =>
		json(
			"DELETE",
			"/ScoutingIndices/" + encodeURIComponent(index.id),
			undefined,
			{version: index.version},
		),
	defaults: () => json("POST", "/ScoutingIndices/defaults"),
};
export const ProviderMatchesAPI = {
	get: (id) => json("GET", `/Players/${id}/provider-matches`),
	preview: (id, file) =>
		upload(`/Players/${id}/provider-matches/preview`, file),
	import: (id, file, fields) =>
		upload(`/Players/${id}/provider-matches`, file, fields),
	indices: (id, params) =>
		json("GET", `/Players/${id}/provider-matches/indices`, undefined, params),
};
